module.exports = __webpack_public_path__ + "static/media/ic_logo@3x.2eb570ff.png";